import VueRouter from 'vue-router'
import torrents from "@/components/torrents";
import search from "@/components/search";
import mainPage from "@/components/mainPage";
import userAndAccount from "@/components/userAndAccount";
import torrentSettings from "@/components/torrentSettings";
import detailLibrary from "@/components/detailLibrary";
import mediastationSettings from "@/components/mediastationSettings";
import topKinozal from "@/components/topKinozal";


const routes = [
    {
        path: '/',
        name: 'start',
        component: mainPage
    },
    {
        path: '/main',
        name: 'main',
        component: mainPage,

    },
    {
        name: 'downloadSettings',
        path: '/downloadSettings',
        component: torrentSettings,
        meta: {
            auth: true
        }
    },
    {
        name: 'top',
        path: '/top',
        component: topKinozal,
        meta: {
            auth: true
        }
    },
    {
        name: 'downloads',
        path: '/downloads',
        component: torrents,
        meta: {
            auth: true
        }
    },
    {
        name: 'search',
        path: '/search',
        component: search,
        meta: {
            auth: true
        }
    },
    {
        name: 'detail',
        path: '/detail/:libId',
        props: true,
        component: detailLibrary,
        meta: {
            auth: true
        }
    },
    {
        name: 'mediastation',
        path: '/mediastation',
        component: mediastationSettings,
        meta: {
            auth: true
        }
    },
    {
        path: '/users',
        name: 'users',
        component: userAndAccount,
        meta: {
            auth: true
        }
    }
]
const router = new VueRouter({
    history: true,
    mode: 'history',
    routes,
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.auth)) {
        if (localStorage.getItem('jwt') === null) {
            next({
                path: '/',
                params: {nextUrl: to.fullPath}
            })
        } else {
            next()
        }
    } else if (to.matched.some(record => record.meta.guest)) {
        if (localStorage.getItem('jwt') === null) {
            next()
        }
    }else {
        next()
    }
})

export default router
